// Base URL of the billing API (Redsys, email, admin, payment links, etc.).
// Prefer the build-time env var; otherwise infer from the host so production
// (served from a zcom.es domain) hits api.zcom.es instead of localhost.
const inferApiBase = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && /(^|\.)zcom\.es$/i.test(window.location.hostname)) {
    return 'https://api.zcom.es';
  }
  return 'http://localhost:5000';
};

export const API_BASE = inferApiBase();

// Submit a Redsys redirect form (returned by the backend) by POSTing to the gateway.
export function postRedsysForm({ url, params }) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  Object.entries(params).forEach(([k, v]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = k;
    input.value = v;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
